import { getWhiteLabelConfig } from '../../white-label-configs/white-label-configs';

export const setupWhiteLabelStyling = () => {
    const config = getWhiteLabelConfig();
    if (!config?.styling) {
        return;
    }

    const link = document.createElement('link');
    link.href = config.styling.fontUrl;
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    Object.entries(config.styling.cssVariables).forEach(([key, value]) => {
        document.documentElement.style.setProperty(key, value);
    });
};
